import Trims from "../components/volumestrims/Trims";
import Volumes from "../components/volumestrims/Volumes";
import TrimsPopularity from "../components/volumestrims/TrimsPopularity";

import ApiVolumesTrims from '../api/volumestrims';

import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from 'react';
import { makes as actionsMakes, models as actionsModels, regions as actionsRegions, fueltypes as actionsFueltypes } from "../store/actions";

const { setSelectedMake, getMakes } = actionsMakes;
const { setSelectedModel, getModels } = actionsModels;
const { getFueltypes } = actionsFueltypes;
const { getRegions } = actionsRegions;

const VolumesTrims = () => {

    const dispatch = useDispatch();

    let selectedMake = useSelector(store => store.makes.selectedMake);
    let selectedModel = useSelector(store => store.models.selectedModel);
    let makes = useSelector(store => store.makes.items);
    let models = useSelector(store => store.models.items);

    const [selectedVolume, setSelectedVolume] = useState(null);
    const [trims, setTrims] = useState([]);
    const [triggerForTrims, setTriggerForTrims] = useState(0);

    useEffect(() => {
        dispatch(getRegions());
        dispatch(getMakes());
        dispatch(getFueltypes());
    }, []);

    useEffect(() => {
        if (selectedMake?.id == -1) {
            dispatch(setSelectedMake(makes[0]));
        }
    }, [makes]);

    useEffect(() => {
        dispatch(getModels(selectedMake.id));
    }, [selectedMake]);

    useEffect(() => {
        setSelectedVolume(null);
    }, [selectedModel]);

    useEffect(() => {
        if (selectedVolume) {
            ApiVolumesTrims.getTrimsByModelAndVolume(selectedModel.id, selectedVolume.id).then(json => {
                setTrims(json.trims);
            });
        }
    }, [selectedVolume, triggerForTrims]);

    useEffect(() => {
        let model = models.find(model => model.id == selectedModel.id);
        if (! model) {
            model = models && models.length ? models[0] : null;
        }
        dispatch(setSelectedModel(model));
    }, [models]);

    const selectMake = e => {
        const idMake = e.target.value;
        const make = makes.find(item => Number(item.id) === Number(idMake));
        dispatch(setSelectedMake(make));
    };

    const selectModel = e => {
        const idModel = e.target.value;
        const model = models.find(item => Number(item.id) === Number(idModel));
        setTimeout(() => {
            dispatch(setSelectedModel(model));
        }, 0);
    };

    const onVolumeSelected = volume => {
        setSelectedVolume(volume);
    };

    const notifyTrims = () => {
        setTriggerForTrims(new Date());
    };

    return (

        <div className="flex flex-wrap -mx-2 overflow-hidden sm:-mx-4 md:-mx-6 lg:-mx-1">

            <div className="my-2 px-2 w-1/4 overflow-hidden sm:my-4 sm:px-4 md:my-6 md:px-6 lg:my-1 lg:px-1">
                <div className="text-lg p-2 bg-gray-900 flex items-center justify-between mb-2">
                    Selected make: 
                    <select value={selectedMake.id} onChange={selectMake} className="text-sm px-2 py-1 my-0 bg-gray-800 border border-gray-700">
                        {makes.map(make => {
                            return <option value={make.id} key={make.id}>{make.name}</option>
                        })}
                    </select>
                </div>
                <div className="text-lg p-2 bg-gray-900 flex items-center justify-between mb-2">
                    Selected model: 
                    <select value={selectedModel.id} onChange={selectModel} className="text-sm px-2 py-1 my-0 bg-gray-800 border border-gray-700">
                        {models.map(model => {
                            return <option value={model.id} key={model.id}>{model.name}</option>
                        })}
                    </select>
                </div>
                <Volumes model={selectedModel} onSelected={onVolumeSelected}/>
            </div>

            <div className="my-2 px-2 w-1/4 overflow-hidden sm:my-4 sm:px-4 md:my-6 md:px-6 lg:my-1 lg:px-1">
                { selectedVolume && <Trims trims={trims} selectedModel={selectedModel} selectedVolume={selectedVolume} notifyTrims={notifyTrims}/> }
            </div>

            <div className="my-2 px-2 w-1/2 overflow-hidden sm:my-4 sm:px-4 md:my-6 md:px-6 lg:my-1 lg:px-1">
                { selectedVolume && <TrimsPopularity model={selectedModel} volume={selectedVolume} trims={trims} /> }
            </div>

        </div>

    );
}

export default VolumesTrims;